import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CsvParserService {

  constructor() { }
  private defaultCSVParserConfig = {
    header: true,
    delimiter: ',',
    noOfRows: -1
};

parse(csvFile: File, config: CSVParserConfig): Observable<Array<any> | NgxCSVParserError> {

    config = {
        ...this.defaultCSVParserConfig,
        ...config
    };

    const ngxCSVParserObserver = new Observable((observer: Observer<Array<any> | NgxCSVParserError>) => {
        try {
            let csvRecords = null;
            if (this.isCSVFile(csvFile)) {
                const reader = new FileReader();
                reader.readAsText(csvFile);

                reader.onload = () => {
                  const csvData = (reader.result as string).trim();
                  if(csvData){
                  const csvRecordsArray = this.csvStringToArray(csvData, config.delimiter, config.noOfRows);
                  const headersRow = this.getHeaderArray(csvRecordsArray);
                  csvRecords = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length, config);

                  observer.next(csvRecords);
                  }
                  else{
                    this.badCSVDataFormatErrorHandler(observer);
                  }
                  observer.complete();
                };

                reader.onerror = () => {
                    this.badCSVDataFormatErrorHandler(observer);
                };

            } else {
                this.notCSVFileErrorHandler(observer);
            }

        } catch (error) {
            this.unknownCSVParserErrorHandler(observer);
        }
    });

    return ngxCSVParserObserver;
}

csvStringToArray(csvDataString: string, delimiter: string, noOfRows: number) {
  const regexPattern = new RegExp((`(\\${delimiter}|\\r?\\n|\\r|^)(?:\"((?:\\\\.|\"\"|[^\\\\\"])*)\"|([^\\${delimiter}\"\\r\\n]*))`), "gi")
  let matchedPatternArray = regexPattern.exec(csvDataString);
  const resultCSV = [[]];
  const rowcount = noOfRows != -1;
  let index = 1;
  while (matchedPatternArray) {
      if (matchedPatternArray[1].length && matchedPatternArray[1] !== delimiter) {
        if(rowcount && resultCSV.length >= noOfRows)
        {
          return resultCSV;
        }
          resultCSV.push([]);
      }
      const cleanValue = matchedPatternArray[2] ?
          matchedPatternArray[2].replace(new RegExp("[\\\\\"](.)", "g"), '$1') : matchedPatternArray[3];
          if(index === 1 && matchedPatternArray[0].charAt(0) === ',')
          {
            resultCSV[resultCSV.length - 1].push('');
          }
          index++;
      resultCSV[resultCSV.length - 1].push(cleanValue);
      matchedPatternArray = regexPattern.exec(csvDataString);
  }
  return resultCSV;
}
getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any, config: any) {
  const dataArr = [];
  const headersArray = csvRecordsArray[0];

  const startingRowToParseData = config.header ? 1 : 0;

  for (let i = startingRowToParseData; i < csvRecordsArray.length; i++) {
      const data = csvRecordsArray[i];

      if (data.length === headerLength && config.header) {

          const csvRecord = {};

          for (let j = 0; j < data.length; j++) {
              if ((data[j] === undefined) || (data[j] === null)) {
                  csvRecord[headersArray[j]] = "";
              } else {
                  csvRecord[headersArray[j]] = data[j].trim();
              }
          }
          dataArr.push(csvRecord);
      } else {
          dataArr.push(data);
      }
  }
  return dataArr;
}
isCSVFile(file: any) {
    return file.name.toLowerCase().endsWith('.csv');
}
getHeaderArray(csvRecordsArr: any) {
  const headers = csvRecordsArr[0];
  const headerArray = [];
  for (const header of headers) {
      headerArray.push(header);
  }
  return headerArray;
}
notCSVFileErrorHandler(observer: Observer<any>) {
    const ngcCSVParserError: NgxCSVParserError =
        this.errorBuilder('NOT_A_CSV_FILE', 'Selected file is not a csv File Type.', 2);
    observer.error(ngcCSVParserError);
}

unknownCSVParserErrorHandler(observer: Observer<any>) {
    const ngcCSVParserError: NgxCSVParserError =
        this.errorBuilder('UNKNOWN_ERROR', 'Unknown error. Please check your file', 404);
    observer.error(ngcCSVParserError);
}

badCSVDataFormatErrorHandler(observer: Observer<any>) {
    const ngcCSVParserError: NgxCSVParserError =
        this.errorBuilder('BAD_CSV_DATA_FORMAT', 'Unable to parse CSV File.', 1);
    observer.error(ngcCSVParserError);
}

errorBuilder(type: string, message: any, code: any): NgxCSVParserError {
    const ngcCSVParserError: NgxCSVParserError = {
      type: type,
      code: code,
      message: message
    };
    return ngcCSVParserError;
}
}
interface CSVParserConfig {
  header?: boolean;
  delimiter?: string;
  noOfRows?: number;
}
export interface NgxCSVParserError {
  type: string;
  code: number;
  message: string;
}
